import loadable from '@loadable/component';
import Redirect from 'app/common/components/redirect';

const ContentSearchContainer = loadable(async () => import('../content-list/components/content-list/index.js'));
const ContentEdit = loadable(async () => import('./components/content-edit/index.js'));
const ContentNav = loadable(async () => import('../common/components/nav/content-nav/index.js'));
const ContentHome = loadable(async () => import('./components/content-home/index.js'));

export default {
  '/data': {
    components: { main: ContentHome, nav: ContentNav },
    '/:shapeName': {
      components: { main: ContentSearchContainer, nav: ContentNav },
      '/create': {
        components: { main: ContentEdit, nav: ContentNav }
      },
      '/:contentId': {
        components: { main: ContentEdit, nav: ContentNav }
      }
    }
  },
  '/content': {
    components: { main: Redirect },
    from: /\/content\//,
    to: '/data/',
    '/*': {
      components: { main: Redirect },
      from: /\/content\//,
      to: '/data/'
    }
  }
};
